import { Select } from 'antd';

const { Option, OptGroup } = Select;

const defaultGetValue = (shop) => shop.value;

export const renderShopOptions = (shops = [], getValue = defaultGetValue) =>
  (shops || []).map((shop) => (
    <Option key={getValue(shop)} value={getValue(shop)}>
      {shop.title}
    </Option>
  ));

// Insegna select options: active companies first, inactive ones below in
// their own group. Flat list when there are no inactive companies.
// Returns Option/OptGroup elements (antd Select accepts only those as children).
// Use with Helpers.addSearchProps() so search works inside groups.
export const renderGroupedShopOptions = ({
  shops = [],
  inactiveShops = [],
  t,
  getValue = defaultGetValue,
}) => {
  if (!inactiveShops?.length) {
    return renderShopOptions(shops, getValue);
  }
  return [
    <OptGroup key='active' label={t('Insegne attive')}>
      {renderShopOptions(shops, getValue)}
    </OptGroup>,
    <OptGroup key='inactive' label={t('Insegne non attive')}>
      {renderShopOptions(inactiveShops, getValue)}
    </OptGroup>,
  ];
};
